import React from 'react';
import { Box } from '@wds/box';
import { Tooltip } from '@wds/tooltip';
import { Button } from '@wds/button'; 
import { Badge } from '@wds/badge'; 
import { IconInfo, IconLock } from '@wds/icons';
import DocuSignBadge from './DocuSignBadge';
import docusignLogo from './docusign-logo.svg';

const DocuSignPaletteConnectedItem = ({ 
    hasSufficientPlan = true, 
    onUpgradeClick 
}) => {
    // If the plan is not sufficient, render the yellow upgrade banner
    if (!hasSufficientPlan) {
        return (
            <Box
                className='docusign-palette-upgrade-banner'
                display='flex'
                flexDirection='column'
                gap={2}
                style={{
                    width: '100%',
                    backgroundColor: '#FEF2CC', // Light yellow background
                    padding: '16px',
                    borderRadius: '8px',
                }}
            >
                <Box display='flex' alignItems='center' gap={2}>
                    <img src={docusignLogo} alt='' height={18} />
                    <strong>{gettext('Introducing Docusign')}</strong>
                    <Badge 
                        style={{ 
                            backgroundColor: '#A6E9D5', // Mint green background
                            color: '#1A3C34', // Dark green text
                            fontWeight: '600'
                        }}
                    >
                        {gettext('New')}
                    </Badge>
                </Box>
                
                <Box style={{ color: '#333333', marginBottom: '4px' }}>
                    {gettext('Collect signatures directly from your forms.')}
                </Box>
                
                <Box>
                    <Button
                        color='upgrade'
                        onClick={onUpgradeClick}
                        iconBefore={<IconLock size="sm" />}
                    >
                        {gettext('Upgrade')}
                    </Button>
                </Box>
            </Box>
        );
    }

    // Default: Return the original connected item if the plan is sufficient
    return (
        <Box
            className='docusign-palette-connected-item'
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            style={{ width: '100%' }}
        >
            <Box display='flex' alignItems='center' gap={2}>
                {gettext('Docusign')}
                <Tooltip
                    placement='top'
                    text={(
                        <span>
                            <strong>{gettext('Disclaimer:')}</strong>
                            {' '}
                            {gettext(
                                'Envelope usage is managed in your DocuSign account. '
                                + 'Ensure you have sufficient quota for your expected volume.',
                            )}
                        </span>
                    )}
                >
                    <IconInfo size='sm' color='darkMuted' />
                </Tooltip>
            </Box>
            <DocuSignBadge variant='connected' />
        </Box>
    );
};

export default DocuSignPaletteConnectedItem;